
    import { renderPage } from '/src/pages/home.js';
    renderPage();
  